export default "__VITE_ASSET__SaGms$AP__"